import React from 'react';
export function DailySpecials() {
  const specials = [{
    name: 'Omakase Sashimi Platter',
    description: "Chef's selection of the freshest catch, served with wasabi and house-made soy",
    price: '$48',
    image: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=800&q=80'
  }, {
    name: 'Wagyu Beef Tataki',
    description: 'Seared A5 wagyu with ponzu, microgreens, and crispy garlic chips',
    price: '$38',
    image: 'https://images.unsplash.com/photo-1544025162-d76694265947?w=800&q=80'
  }, {
    name: 'Miso Black Cod',
    description: '48-hour marinated black cod, charred to perfection with seasonal vegetables',
    price: '$42',
    image: 'https://images.unsplash.com/photo-1580959375944-57c8e2a97128?w=800&q=80'
  }, {
    name: 'Truffle Uni Don',
    description: 'Premium sea urchin over warm sushi rice, finished with black truffle oil',
    price: '$52',
    image: 'https://images.unsplash.com/photo-1583623025817-d180a2221d0a?w=800&q=80'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black" data-id="element-1">
      <div className="max-w-7xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4" data-id="element-4">
            Today's Specials
          </h2>
          <p className="text-xl text-gray-300" data-id="element-5">
            Handcrafted daily by our culinary team
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-6">
          {specials.map((special, index) => <div key={index} className="group bg-slate-950 rounded-2xl overflow-hidden hover:transform hover:scale-[1.02] transition-all duration-300 border border-slate-800" data-id="element-7">
              <div className="aspect-[4/3] overflow-hidden" data-id="element-8">
                <img src={special.image} alt={special.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-9" />
              </div>
              <div className="p-6" data-id="element-10">
                <div className="flex justify-between items-start mb-3" data-id="element-11">
                  <h3 className="text-2xl font-semibold text-white" data-id="element-12">
                    {special.name}
                  </h3>
                  <span className="text-2xl font-bold text-amber-400" data-id="element-13">
                    {special.price}
                  </span>
                </div>
                <p className="text-gray-300 leading-relaxed" data-id="element-14">
                  {special.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}